var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.025012C5.86667 0.025012 5.73734 0.0500126 5.612 0.100013C5.48667 0.150013 5.38267 0.216679 5.3 0.300013L0.700003 4.90001C0.516669 5.08335 0.425003 5.31668 0.425003 5.60001C0.425003 5.88335 0.516669 6.11668 0.700003 6.30001C0.883336 6.48335 1.11667 6.57501 1.4 6.57501C1.68334 6.57501 1.91667 6.48335 2.1 6.30001L6 2.40001L9.9 6.30001C10.0833 6.48335 10.3167 6.57501 10.6 6.57501C10.8833 6.57501 11.1167 6.48335 11.3 6.30001C11.4833 6.11668 11.575 5.88335 11.575 5.60001C11.575 5.31668 11.4833 5.08335 11.3 4.90001L6.7 0.300013C6.6 0.200013 6.49167 0.129012 6.375 0.0870123C6.25834 0.0450125 6.13334 0.0243454 6 0.025012Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBlack);
export default __webpack_public_path__ + "static/media/upArrowBlack.cf011bf8aab2850490a62c86d890d9ca.svg";
export { ForwardRef as ReactComponent };